import { cn } from '@/shared/shadcn/lib/utils';

import { ScrollArea } from '@/shared/shadcn/raw/scroll-area';

import LogoGatePlusFull from '@/shared/assets/svg/logo/logo-gate_plus-full.svg?react';

import SigninLogo from './_assets/signin-logo.svg?react';
import SigninAca from './_assets/signin-aca.svg?react';

interface AuthLayoutProps {
  imgUrl?: string;
  children: React.ReactNode;
}

/** auth 레이아웃 컴포넌트 */
export default function AuthLayout({ imgUrl, children }: AuthLayoutProps) {
  return (
    <div className='font-pretendard flex h-full justify-end'>
      <div
        className={cn(
          'relative hidden h-full flex-75 bg-slate-400',
          'md:block' // 반응형 class name
        )}>
        <div className='relative h-full w-full'>
          {imgUrl ? (
            <img src={imgUrl} alt='auth-img' className='h-full w-full object-cover' />
          ) : (
            <div className='bg-blue-gray-50 relative h-full w-full'>
              <div className='absolute top-1/2 left-25 flex -translate-y-1/2 flex-col gap-2'>
                <div className='flex items-center gap-4 p-2.5'>
                  <SigninLogo /> <SigninAca />
                </div>
                <p className='p-2.5 text-[#919191]'>Get closer to your dream school with GATE+ ACA</p>
              </div>
            </div>
          )}
        </div>

        {imgUrl && (
          <div className='absolute top-10 left-10 h-10.5 w-37.25'>
            <i aria-hidden='true'>
              <LogoGatePlusFull className='text-basic-white' />
            </i>
          </div>
        )}
      </div>

      {/* 로그인 폼 — 모바일: 전체 너비, md+: 우측 고정 패널 */}
      <section
        className={cn(
          'flex h-full w-full flex-col',
          'md:min-w-[31.6rem] md:flex-44' // 반응형 class name
        )}>
        {/* 모바일 전용 로고 */}
        <div className='flex justify-center pt-10 pb-6 md:hidden'>
          <i aria-hidden='true'>
            <LogoGatePlusFull className='text-blue-600' />
          </i>
        </div>

        {/* 컨테이너 가운데 정렬 */}
        <div className='tw-flex-center h-full w-full flex-col'>
          {/* 전체 높이를 차지하는 스크롤 컨테이너 ( flex가 아니여서 스크롤 등에 잘리지 않음 ) */}
          <ScrollArea className='w-full max-w-122.5 overflow-y-auto'>
            <div
              className={cn(
                'px-6',
                'sm:px-10 md:px-16' // 반응형 class name
              )}>
              {children}
            </div>
          </ScrollArea>
        </div>
      </section>
    </div>
  );
}
